import PropTypes from 'prop-types';
import styles from './style.m.less';

export default function EntityPreview({ title, subtitle }) {
    return (
        <section className={styles.preview}>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.subtitle}>{subtitle}</div>
        </section>
    );
}

EntityPreview.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.node,
};
